import http from "../http-common";
import authHeader from '../auth-header';

export default class ClienteService {

    buscarclientes(){
        return http.get("jaapzproceso/cliente/buscarclientes", { headers: authHeader() });
    }
    
    validardatoscliente(cedula, id){
        return http.get("jaapzproceso/cliente/validardatoscliente/" + cedula + "/" + id , { headers: authHeader() });
    }

    guardarCliente(cliente){
        return http.post("jaapzproceso/cliente/guardar" , cliente, { headers: authHeader() });
    }

    buscarClientesPlanillar(idanio, idmes){
        return http.get("jaapzproceso/cliente/buscarClientesPlanillar/" + idanio + "/" + idmes, { headers: authHeader() });
    }

    consultarClientes(){
        return http.get("jaapzproceso/cliente/consultarClientes", { headers: authHeader() });
    }

    buscarClientesActivos(){
        return http.get("jaapzproceso/cliente/buscarClientesActivos", { headers: authHeader() });
    }
}